var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.currentValue,
          expression: "currentValue",
        },
      ],
      on: {
        change: [
          function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.currentValue = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          _vm.changeSelection,
        ],
      },
    },
    [
      _vm.unchoose
        ? _c(
            "option",
            {
              attrs: {
                value: "",
              },
            },
            [_c("translate", [_vm._v("kein Ordner ausgewählt")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.context.type === "courses"
        ? _c(
            "optgroup",
            {
              attrs: {
                label: _vm.textOptGroupCourse,
              },
            },
            _vm._l(_vm.loadedCourseFolders, function (folder) {
              return _c(
                "option",
                {
                  key: folder.id,
                  domProps: {
                    value: folder.id,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(folder.attributes.name) +
                      "\n        "
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowUserFolders
        ? _c(
            "optgroup",
            {
              attrs: {
                label: _vm.textOptGroupUser,
              },
            },
            _vm._l(_vm.loadedUserFolders, function (folder) {
              return _c(
                "option",
                {
                  key: folder.id,
                  domProps: {
                    value: folder.id,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(folder.attributes.name) +
                      "\n        "
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }